<div class="text-neutral-700 text-base">
  <span>{{ 'prepaid-account-top-up-modal.current-balance' | translate }} : </span>
  @if (isLoading$ | async) {
    <img
      src="assets/images/spinner.svg"
      alt=""
      class="inline-block h-4 w-4"
    />
  } @else if (userBalanceLoaded()) {
    <span class="font-bold">
      <app-price-atom
        [amount]="balanceBeforeOrderInCents() ?? 0"
        [format]="true"
        [bold]="false"
      />
    </span>
  } @else {
    <span>-</span>
  }
</div>
